export default __webpack_public_path__ + "static/media/sneaker purple.141add7a.png";